import { Routes } from "@angular/router";

export const appRoutes: Routes = [
  {
    path: "tabs",
    loadChildren: () => import("./tabs/tabs/tabs.routes").then((m) => m.routes),
  },
  {
    path: "login",
    loadChildren: () =>
      import("./pages/login/login-routing.module").then((m) => m.routes),
  },
  {
    path: "acesso",
    loadChildren: () =>
      import("./components/sem-acesso/sem-acesso-routing.module").then(
        (m) => m.routes
      ),
  },
  {
    path: "onboarding",
    loadChildren: () =>
      import("./pages/onboarding/onboarding-routing.module").then(
        (m) => m.routes
      ),
  },
];
